<main class="flex min-h-screen flex-col">
  <app-header />
  <div class="grow px-8 py-12 lg:p-16 xl:px-24">
    <app-breadcrumb class="-mt-8 mb-8 block lg:-mt-12 lg:mb-12" />
    <router-outlet />
  </div>
  <app-footer />
</main>
